import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { HomeComponent } from './components/home/home.component';
import { AccessDeniedComponent } from './components/access-denied/access-denied.component';
import { OfflineComponent } from './components/offline/offline.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { MaintainancePageComponent } from './components/maintainance-page/maintainance-page.component';

import { MsalGuard, MsalRedirectComponent } from '@azure/msal-angular';
import { ConfigLoaderService } from './Shared/Services/Config/config-loader.service';
const environment = (ConfigLoaderService.settings?.env?.name || '').toUpperCase();

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    pathMatch: 'full'
  },

  {
    path: 'home',
    component: HomeComponent,
    canActivate: environment.toUpperCase()==="DEVELOPMENT"?[]:[MsalGuard]
  },

  {
    path: 'error',
    component: AccessDeniedComponent,
    canActivate: environment.toUpperCase()==="DEVELOPMENT"?[]:[MsalGuard]
  },

  {
    path: 'offline',
    component: OfflineComponent
  },

  {
    path: 'maintenance',
    component: MaintainancePageComponent
  },

  {
    path: '404',
    component: PageNotFoundComponent
  },

  {
    path: 'auth',
    component: MsalRedirectComponent
  },

  {
    path: '**',
    redirectTo: '404'
  }
];

const isIframe = window !== window.parent && !window.opener;

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      useHash: true,
      initialNavigation: 'enabledBlocking'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
